import { ChatBubbleOvalLeftIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ActionIcon } from '@mantine/core';
import { ChatSession } from 'src/interfaces/Chat';

interface ChatHistoryTileProps {
  item: ChatSession;
  selected: boolean;
  onPress: (chatSession: ChatSession) => void;
  onPressDelete: (id: string) => void;
}

const ChatHistoryTile: React.FC<ChatHistoryTileProps> = ({
  item,
  selected,
  onPress,
  onPressDelete,
}) => (
  <div
    className={`flex flex-row items-center justify-between px-2 my-1 rounded ${
      selected ? 'bg-gray-200' : 'hover:bg-gray-100'
    }`}
  >
    <div
      className="flex items-center max-w-[90%] w-full cursor-pointer py-2"
      onClick={() => onPress(item)}
    >
      <div className="h-5 w-5 mr-2">
        <ChatBubbleOvalLeftIcon className="h-5 w-5" />
      </div>
      <span className="text-sm truncate">{item.title}</span>
    </div>
    <ActionIcon
      onClick={(e) => {
        e.stopPropagation();
        onPressDelete(item.id);
      }}
      className="text-red-500 hover:text-red-700"
    >
      <TrashIcon className="mr-2 w-20 h-20" />
    </ActionIcon>
  </div>
);

export default ChatHistoryTile;
